import { NgModule } from '@angular/core';
import { Route, RouterModule } from '@angular/router';

import {
  LeafAuthGuardModule, LeafAuthGuardService,
} from '@input-output-labs/ngleaf';
import { MainLayoutComponent } from 'component/main-layout/main-layout.component';
import { MainLayoutModule } from 'component/main-layout/main-layout.module';

const routes: Route[] = [
  {
    path: '',
    canActivate: [LeafAuthGuardService],
    component: MainLayoutComponent,
    children: [
      {
        path: '',
        redirectTo: '/dashboard',
        pathMatch: 'full',
      },
      {
        path: 'dashboard',
        loadChildren: () => import('./dashboard/dashboard.module').then(m => m.DashboardModule)
      },
      {
        path: 'variables',
        loadChildren: () => import('./variables/variables.module').then(m => m.VariablesModule)
      },
      {
        path: 'flux',
        loadChildren: () => import('./inflows/inflows.module').then(m => m.InflowsModule)
      },
      {
        path: 'ventes',
        loadChildren: () => import('./sales/sales.module').then(m => m.SalesModule)
      },
      {
        path: 'simulations',
        loadChildren: () => import('./simulations/simulations.module').then(m => m.SimulationsModule)
      },
      {
        path: 'comparaisons',
        loadChildren: () => import('./comparisons/comparisons.module').then(m => m.ComparisonsModule)
      },
      {
        path: 'objectifs',
        loadChildren: () => import('./objectives/objectives.module').then(m => m.ObjectivesModule)
      },
      {
        path: 'settings',
        loadChildren: () => import('./account-settings/account-settings.module').then(m => m.AccountSettingsModule)
      },
      {
        path: 'members-rights',
        loadChildren: () => import('./members-rights/members-rights.module').then(m => m.MembersRightsModule)
      },
      {
        path: 'admin/organizations',
        loadChildren: () => import('./admin/organizations/organizations.module').then(m => m.OrganizationsModule)
      },
      {
        path: 'admin/workspace-settings',
        loadChildren: () => import('./admin/workspace-settings/workspace-settings.module').then(m => m.WorkspaceSettingsModule)
      },
    ]
  },
  {
    path: 'welcome',
    loadChildren: () => import('./welcome/welcome.module').then(m => m.WelcomeModule)
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes),
    LeafAuthGuardModule,
    MainLayoutModule,
  ],
  exports: [RouterModule],
})
export class AppRouteModule {}
